import { Dependency, DefaultDependencySettings } from "index";
import DependencyBase from "./../DependecyBase";
import React from "react";

declare global {
    interface Window {
        CookieInformation?: any;
        cicc?: object;
    }
}

export interface CookieInformationSettings extends DefaultDependencySettings {
    locale: string;
    helmetComponent: React.ComponentType;
}
class CookieInformation extends DependencyBase<CookieInformationSettings> {
    static instance: CookieInformation | undefined = undefined;

    static defaultProps = {
        consentModeEnabled: false,
    };

    // This feels like a bit of a hack...
    static _componentDependencies: Dependency[] = [];
    public static dependency = () => this._componentDependencies.every((dependency) => dependency());

    constructor(prop: CookieInformationSettings) {
        super(prop);
        CookieInformation._componentDependencies.push(this.dependency);
        CookieInformation.instance = this;
    }

    // We save all events until the user has made a choice regarding consent. (If cookie exists)
    public dependency = () => !!document?.cookie?.split?.("; ")?.find?.((v) => v?.match?.("^CookieInformationConsent"));

    public static onScriptLoaded = () => {
        // We can't do anything here, since Cookieinformation injects the consent settings directly into the dataLayer.
    };

    render = () => {
        const { locale = "EN", consentModeEnabled, helmetComponent: Helmet } = this.props as CookieInformationSettings;

        return (
            <Helmet>
                <script>
                    {`(function() {
                        const elements = document.getElementsByTagName('script')[0];
                        const script = document.createElement('script');
                        script.onload = function () {return window.grebban.gtm.scriptCallback('CookieInformation');}
                        script.src = 'https://policy.app.cookieinformation.com/uc.js';
                        script.type = 'text/javascript';
                        script.id = 'CookieConsentScript'
                        ${consentModeEnabled} && script.setAttribute('data-gcm-version', '2.0');
                        script.setAttribute('data-culture', '${locale}')
                        script.setAttribute('data-gcm-enabled', ${consentModeEnabled})
                        elements.parentNode.insertBefore(script, elements);
                    })();
                `}
                </script>
            </Helmet>
        );
    };
}

export default CookieInformation;
